import { styled } from "@mui/system";
import { Box } from "@mui/material";

export const Title = styled("div")(({ theme }) => ({
  fontSize: "16px"
}));

export const GroupLabel = styled("h4")(({ theme }) => ({
  marginTop: "15px",
  marginBottom: "7px",
  fontSize: "16px",
  fontWeight: "400",
  lineHeight: "1.9",
  color: "#373737"
}));

export const FlexContainer = styled(Box)(({ theme }) => ({
  marginTop: "0",
  marginBottom: "0"
}));

export const StyledDivider = styled("div")(({ theme }) => ({
  marginTop: "30px",
  borderBottom: "solid 1px rgba(230, 230, 230, 0.5)"
}));

export const ControlsWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "flex-end",
  margin: "20px 0 0"
}));

export const RelativeBox = styled(Box)(({ theme }) => ({
  position: "relative"
}));

export const TabletBox = styled(Box)(({ theme }) => ({
  [theme.breakpoints.only("xs")]: {
    marginBottom: "20px"
  }
}));

export const Container = styled("div")(({ theme }) => ({
  top: "15px",
  right: "-100px",
  [theme.breakpoints.only("xs")]: {
    top: "70px",
    right: "12px"
  }
}));

export const MarginBottomBox = styled(Box)(({ theme }) => ({
  [theme.breakpoints.only("xs")]: {
    marginBottom: "45px"
  }
}));

export const ButtonWrapper = styled("div")(({ theme }) => ({
  width: "100%",
  display: "flex",
  justifyContent: "flex-end",
  margin: "40px 0"
}));

export const Text = styled("div")(({ theme }) => ({
  fontSize: 14,
  padding: 15
}));
